import { ColorsHex } from 'components/global/ds/ColorPicker/ColorPicker'
import { isNextDay, timeToNumbers } from 'components/global/form/formNormalize'

const colors: { hex: ColorsHex }[] = [
  { hex: '#F084AC' },
  { hex: '#FB9CA2' },
  { hex: '#FFCB9D' },
  { hex: '#FCE292' },
  { hex: '#A6D98D' },
  { hex: '#B8DACF' },
  { hex: '#D9B1D2' },
  { hex: '#D6C3AB' },
]

export type ShiftPresetValues = {
  allowed_delay: number | string
  allowed_shortage: number | string
  overtime: number | string
  flexible_duration: number | string
  clocking_in_start_duration: number | string
  clocking_in_end_duration: number | string
  clocking_out_start_duration: number | string
  clocking_out_end_duration: number | string
  is_flexibility: boolean
  is_overtime: boolean
  isStartCalculating: boolean
  start_time: string
  end_time: string
  minimum_overtime: number
  overtimeShiftRole: 'after_shift_duration' | 'before_shift_end_time'
  id?: number
  name_ar?: null | string
  name_en: string
  name_i18n?: string
  clock_out_not_required: boolean
  is_end_time_next_day: boolean
  color: ColorsHex
  effective_date: string
  overtime_shift_included?: boolean
  overtime_requires_completing_wh?: boolean
  overtimeType: 'after_shift_duration' | 'included_in_shift_duration'
  is_custom?: boolean
  open_shift_duration: string
  open_shift_type: 'Open' | 'Timeframe'
}

export type ShiftPresetReturn = {
  allowed_delay: number | string
  allowed_shortage: number | string
  clock_out_not_required: boolean
  clocking_in_end_duration: number | string
  clocking_in_start_duration: number | string
  clocking_out_end_duration: number | string
  clocking_out_start_duration: number | string
  color: ColorsHex
  effective_date: string
  end_time: string
  flexible_duration: string | number
  is_end_time_next_day: boolean
  minimum_overtime: string | number
  name_ar?: string | null
  name_en: string
  overtime: string | number
  overtime_requires_completing_wh: boolean
  overtime_shift_included: boolean
  start_time: string
  is_custom?: boolean
  open_shift_duration: number
  open_shift_type: 'Open' | 'Timeframe'
}

// Generate random color if there is no color select
export const generateRandomColor = (color?: ColorsHex | ''): ColorsHex =>
  color || colors[Math.floor(Math.random() * 8)]?.hex

export const handelShiftPresets = (
  values: ShiftPresetValues,
  withCustom?: boolean,
): ShiftPresetReturn => {
  const open_shift_duration = timeToNumbers(values?.open_shift_duration)

  return {
    allowed_delay: values?.allowed_delay,
    allowed_shortage: values?.allowed_shortage,
    clock_out_not_required: values?.clock_out_not_required || false,
    clocking_in_end_duration: values?.clocking_in_end_duration || 0,
    clocking_in_start_duration: values?.clocking_in_start_duration || 0,
    clocking_out_end_duration: values?.clocking_out_end_duration || 0,
    clocking_out_start_duration: values?.clocking_out_start_duration || 0,
    color: generateRandomColor(values?.color),
    effective_date: values?.effective_date,
    end_time: values?.end_time,
    flexible_duration: values?.flexible_duration || 0,
    is_end_time_next_day: isNextDay(
      values.start_time?.toLowerCase(),
      values.end_time?.toLowerCase(),
    ),
    minimum_overtime:
      !values.isStartCalculating || !values?.is_overtime ? 0 : values?.minimum_overtime,
    name_ar: values?.name_ar || null,
    name_en: values?.name_en,
    overtime: values?.is_overtime ? values?.overtime : 0,
    overtime_requires_completing_wh: values?.overtimeShiftRole === 'after_shift_duration',
    overtime_shift_included: values?.overtimeType === 'included_in_shift_duration',
    start_time: values?.start_time,
    ...(values?.open_shift_type && {
      open_shift_type: values?.open_shift_type,
      open_shift_duration: open_shift_duration ? open_shift_duration.totalMinutes : 0,
    }),
    ...(withCustom && { is_custom: !values?.is_custom }),
  }
}
